// extracted by mini-css-extract-plugin
export var item = "blog-item-module--item--nk0UG";
export var author = "blog-item-module--author--18a3r";
export var title = "blog-item-module--title--30IxD";
export var content = "blog-item-module--content--PJjG5";
export var link = "blog-item-module--link--9yW4X";